import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	Button,
	FullBar,
	Label,
	DialogHandler,
} from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import { updateLocalBrand } from "assets/js/scenes/brand/actions";

export const BrandImage = (props) => {
	const [selectedFile, setSelectedFile] = useState([]);
	const [extraInfo, setExtraInfo] = useState({});
	const [currentImg, setCurrentImg] = useState(props.defaultImg);

	useEffect(() => {}, []);

	function getExtraInformation(e, src, file) {
		if (
			e.currentTarget.naturalWidth !== props.defaultWidth ||
			e.currentTarget.naturalHeight !== props.defaultHeight
		) {
			DialogHandler.show({
				type: "warning",
				title: <Translate value="app-brand-illustrations-size-error-title" />,
				content: (
					<Translate
						value="app-brand-illustrations-size-error-desc"
						width={props.defaultWidth}
						height={props.defaultHeight}
					/>
				),
				primaryBtnText: <Translate value="app-general-got-it" />,
				primaryBtnOnClick: () => {
					DialogHandler.hide();
					setSelectedFile([]);
					setExtraInfo({});
					setCurrentImg(props.defaultImg);
				},
			});
		} else {
			setCurrentImg(src);
			setSelectedFile(file);

			setExtraInfo({
				width: e.currentTarget.naturalWidth || "",
				height: e.currentTarget.naturalHeight || "",
			});

			props.updateLocalBrand(
				props.path,
				src,
				{ value: src, valid: "valid" },
				src === props.defaultImg
			);
		}
	}

	function onReplace(e) {
		//Change selector to find input if we need to change the structure
		e.currentTarget.parentElement.parentElement.parentElement.children[0].click();
	}

	function onFileChange(e) {
		const file = e.currentTarget.files[0];
		const reader = new FileReader();

		reader.onload = function (e) {
			let img = document.createElement("img");
			const src = e.target.result;
			img.src = src;

			img.onload = (e) => {
				getExtraInformation(e, src, file);
			};
		};

		reader.readAsDataURL(file);
	}

	return (
		<div className="brandElement-image">
			<input
				accept="image/*"
				type="file"
				autoComplete="off"
				tabIndex="-1"
				style={{ display: "none" }}
				onChange={onFileChange}
			/>
			<div className="illustrationContainer">
				<img src={currentImg} />
			</div>
			<div className="extraInfo">
				<div>
					<p className="name">{props.imgName}</p>
					<Button
						size="xsmall"
						shapeStyle="stroke"
						colorTheme="grey"
						text={<Translate value="app-general-replace" />}
						onClick={onReplace}
					/>
				</div>
				<div>
					<p>
						<Translate
							value="app-brand-illustrations-general-desc"
							width={props.defaultWidth}
							height={props.defaultHeight}
						/>
					</p>
				</div>
				<div>
					{props.unpublishedData?.[props.path] && (
						<Label
							shapeStyle="fill"
							text={
								<Translate value="app-brand-modal-tabs-label-unpublished" />
							}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

BrandImage.propTypes = {
	unpublishedData: PropTypes.object,
	path: PropTypes.string,
	imgName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	defaultImg: PropTypes.string,
	defaultWidth: PropTypes.number,
	defaultHeight: PropTypes.number,
	updateLocalBrand: PropTypes.func,
};

BrandImage.defaultProps = {
	defaultWidth: 800,
	defaultHeight: 700,
};

export default withRouter(
	connect(
		(state) => {
			return {
				unpublishedData: state.localBrand.unpublishedData,
			};
		},
		(dispatch) =>
			bindActionCreators(
				{
					updateLocalBrand,
				},
				dispatch
			)
	)(BrandImage)
);
